import { render, staticRenderFns } from "./VenueSelector.vue?vue&type=template&id=2b0517b8&scoped=true"
import script from "./VenueSelector.vue?vue&type=script&lang=ts"
export * from "./VenueSelector.vue?vue&type=script&lang=ts"
import style0 from "./VenueSelector.vue?vue&type=style&index=0&id=2b0517b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0517b8",
  null
  
)

export default component.exports